import { writable, get } from 'svelte/store';
export const createSelectedDayOptionStore = () => {
    const selectedDayStore = writable(1);
    const setSelectedDay = (day) => selectedDayStore.set(day);
    const getSelectedDay = () => get(selectedDayStore);
    return {
        subscribe: selectedDayStore.subscribe,
        setSelectedDay,
        getSelectedDay,
    };
};
